import React, { ReactNode, ReactText, useEffect, useState } from 'react'
import styles from './Hints.module.sass'
import List from '../List/List'
import InfiniteScroll from '../../../etc/scroll/InfiniteScroll'
import ShadowContainer from '../../../etc/popover/ShadowContainer/ShadowContainer'
import Popover from '../../../etc/Popover'

interface Props<Item> {
    items: readonly Item[],
    children: (args: {
        isOpen: boolean,
        open: () => void,
        close: () => void,
        toggle: () => void,
    }) => JSX.Element,
    onClick?: (item: Item) => void,
    onToggle?: (open: boolean) => void,
    renderer: (item: Item) => ReactNode,
    itemToKey: (item: Item) => ReactText,
    onMore?: () => void,
    showEmpty?: boolean,
}

const Hints = <Item extends unknown>({onToggle, ...props}: Props<Item>): JSX.Element => {
    const [open, setOpen] = useState(false)

    useEffect(() => {
        onToggle?.(open)
    }, [open, onToggle])

    return <Popover
        isOpen={open}
        onClickOutside={() => setOpen(false)}
        content={state => <ShadowContainer state={state}>
            <InfiniteScroll onReach={props.onMore}>
                <List<Item>
                    className={styles.list}
                    showEmpty={props.showEmpty}
                    toClassName={() => styles.item}
                    data={props.items}
                    render={props.renderer}
                    toKey={props.itemToKey}
                    onClick={item => {
                        setOpen(false)
                        props.onClick?.(item)
                    }}
                />
            </InfiniteScroll>
        </ShadowContainer>}
    >
        {props.children({
            isOpen: open,
            open: () => setOpen(true),
            close: () => setOpen(false),
            toggle: () => setOpen(!open),
        })}
    </Popover>
}

export default Hints